import React, { useState, useEffect } from 'react';
import api from '../services/api';
import toast from '../services/toast';
import { parseDataSQL } from '../utils/dataJogo';
import './EnviarComprovante.css';

const PIX_KEY = '74981491871';

function statusBadge(s) {
  if (s === 'APROVADO') return <span className="badge badge-success">Aprovado</span>;
  if (s === 'REJEITADO') return <span className="badge badge-danger">Rejeitado</span>;
  return <span className="badge badge-warning">Pendente</span>;
}

export default function EnviarComprovante() {
  const [arquivo, setArquivo] = useState(null);
  const [historico, setHistorico] = useState([]);
  const [msg, setMsg] = useState('');
  const [erro, setErro] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.get('/comprovantes/meus').then(setHistorico).catch(() => {});
  }, []);

  async function copiarChave() {
    try {
      await navigator.clipboard.writeText(PIX_KEY);
      toast.success('Chave PIX copiada com sucesso!');
    } catch {
      toast.error('Não foi possível copiar. Copie manualmente: ' + PIX_KEY);
    }
  }

  async function handleEnviar(e) {
    e.preventDefault();
    setMsg(''); setErro('');
    if (!arquivo) return setErro('Selecione um arquivo.');
    setLoading(true);
    try {
      const fd = new FormData();
      fd.append('arquivo', arquivo);
      await api.upload('/comprovantes', fd);
      setMsg('Comprovante enviado! Aguarde a aprovação.');
      toast.success('Comprovante enviado com sucesso!');
      setArquivo(null);
      const h = await api.get('/comprovantes/meus');
      setHistorico(h);
    } catch (err) {
      setErro(err.message);
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div>
      <h1 className="page-title">Enviar Comprovante PIX</h1>
      <div className="comp-info">
        <span className="comp-valor"> 9,99</span>
        <p>Realize o pagamento via PIX e envie o comprovante abaixo para ter sua assinatura ativada.</p>
        <div className="pix-key-box">
          <span className="pix-key-label">Chave PIX</span>
          <span className="pix-key-value">{PIX_KEY}</span>
          <button className="btn-copy-pix" onClick={copiarChave} type="button">
            📋 Copiar Chave PIX
          </button>
        </div>
      </div>
      <form onSubmit={handleEnviar} className="card" style={{ marginBottom: 24 }}>
        <div className="form-group">
          <label>Arquivo (JPG, PNG ou PDF)</label>
          <div className="file-upload-area">
            {arquivo ? (
              <div className="file-selected">
                <span>📎 {arquivo.name}</span>
                <button type="button" className="btn-remove" onClick={() => setArquivo(null)}>✕</button>
              </div>
            ) : (
              <label className="file-label">
                <span>📤 Selecionar arquivo</span>
                <input type="file" accept=".jpg,.jpeg,.png,.pdf" onChange={e => setArquivo(e.target.files[0])} style={{ display: 'none' }} />
              </label>
            )}
          </div>
        </div>
        {msg && <div className="alert alert-success">{msg}</div>}
        {erro && <div className="alert alert-error">{erro}</div>}
        <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
          {loading ? 'Enviando...' : 'Enviar Comprovante'}
        </button>
      </form>

      <h2 className="sub-title">Histórico</h2>
      {historico.map(h => (
        <div key={h.id} className="comp-item">
          <div className="comp-item-info">
            <span className="comp-data">{parseDataSQL(h.created_at).toLocaleDateString('pt-BR')}</span>
            {statusBadge(h.status)}
          </div>
          {h.observacao && <p className="comp-obs">Obs: {h.observacao}</p>}
        </div>
      ))}
      {historico.length === 0 && <p style={{ color: 'var(--text2)', textAlign: 'center', padding: 30 }}>Nenhum comprovante enviado.</p>}
    </div>
  );
}
